export var getDefaultStyleSheet = _ref => {
  var {
    allowTextTruncationAndWrapping,
    designContext,
    isVisible,
    maxWidth,
    position,
    shouldHavePaddingTop,
    slotMinHeight,
    topPaddingToTitle
  } = _ref;
  var gapBetweenRightSlotAndChevron = designContext.get('space/100').value();
  return {
    sideSlotWrapper: {
      alignItems: position === 'top' || position === 'title' ? 'flex-start' : 'center',
      alignSelf: position === 'centered' || position === 'centered-exclude-slot-bottom' ? 'stretch' : 'flex-start',
      flexBasis: 'auto',
      flexShrink: allowTextTruncationAndWrapping ? 1 : 0,
      flexDirection: 'row',
      maxWidth,
      minHeight: position === 'balanced' ? slotMinHeight : undefined,
      paddingTop: position === 'title' ? topPaddingToTitle : undefined,
      opacity: isVisible ? 1 : 0
    },
    sideSlotChildrenWrapper: {
      alignItems: 'center',
      flexDirection: 'row',
      flexShrink: 1,
      gap: gapBetweenRightSlotAndChevron
    },
    middleSlot: {
      paddingTop: shouldHavePaddingTop ? 6 : 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map